import { Component, OnInit } from '@angular/core';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  userName!: string;
  cardDescription!: string;
  constructor(private readonly authSvc: UserAuthService) {}

  ngOnInit(): void {
    const profileDetails = this.authSvc.getProfileDetails();
      profileDetails?.subscribe((userDetails: any) => {
        this.userName =
          userDetails?.displayName ||
          `${userDetails?.givenName} ${userDetails?.surname}`;
      });
    this.cardDescription = `Kroger needs help identifying the right tax code for new items and family tree branches.
    To identify and resolve these items, click Get Started below:`;
  }
}
